import request from '@/utils/request'

// 查询平台默认抽成比例列表
export function listProportion(query) {
  return request({
    url: '/zb/proportion/list',
    method: 'get',
    params: query,
  })
}

// 查询平台默认抽成比例分页
export function pageProportion(query) {
  return request({
    url: '/zb/proportion/page',
    method: 'get',
    params: query,
  })
}

// 查询平台默认抽成比例详细
export function getProportion(data) {
  return request({
    url: '/zb/proportion/detail',
    method: 'get',
    params: data,
  })
}
export function info() {
  return request({
    url: '/zb/proportion/info',
    method: 'get',
  })
}

// 新增平台默认抽成比例
export function addProportion(data) {
  return request({
    url: '/zb/proportion/add',
    method: 'post',
    data: data,
  })
}

// 修改平台默认抽成比例
export function updateProportion(data) {
  return request({
    url: '/zb/proportion/edit',
    method: 'post',
    data: data,
  })
}

// 删除平台默认抽成比例
export function delProportion(data) {
  return request({
    url: '/zb/proportion/delete',
    method: 'post',
    data: data,
  })
}
